import { render } from "./AppTableColumn.vue?vue&type=template&id=52432ccf&scoped=true"
import script from "./AppTableColumn.vue?vue&type=script&lang=js"
export * from "./AppTableColumn.vue?vue&type=script&lang=js"

import "./AppTableColumn.vue?vue&type=style&index=0&id=52432ccf&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52432ccf"]])

export default __exports__